import { __extends } from "tslib";
var ParameterRequirementMismatchError = /** @class */ (function (_super) {
    __extends(ParameterRequirementMismatchError, _super);
    function ParameterRequirementMismatchError(_command, _paramName, _paramSpec, _givenValue) {
        var _a;
        var _this = _super.call(this, "required parameter \"" + _paramName + "\" did not validate against " + ((_a = _paramSpec.type) !== null && _a !== void 0 ? _a : 'regex') + " validation: \"" + _givenValue + "\"") || this;
        _this._command = _command;
        _this._paramName = _paramName;
        _this._paramSpec = _paramSpec;
        _this._givenValue = _givenValue;
        Object.setPrototypeOf(_this, ParameterRequirementMismatchError.prototype);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ParameterRequirementMismatchError);
        }
        return _this;
    }
    Object.defineProperty(ParameterRequirementMismatchError.prototype, "command", {
        get: function () {
            return this._command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParameterRequirementMismatchError.prototype, "paramName", {
        get: function () {
            return this._paramName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParameterRequirementMismatchError.prototype, "paramSpec", {
        get: function () {
            return this._paramSpec;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParameterRequirementMismatchError.prototype, "givenValue", {
        get: function () {
            return this._givenValue;
        },
        enumerable: false,
        configurable: true
    });
    return ParameterRequirementMismatchError;
}(Error));
export { ParameterRequirementMismatchError };
